module.exports = __webpack_public_path__ + "static/media/blue-pg2.25395999.png";